<template>
    <div id="telematicsReadingList">
        <div :class="`loader${loaderClass}`" v-show="loading"></div>
        <template v-if="assetwarrantiesVal != undefined">
            <div class="bg-white data-table p-0">
                <vue-good-table
                    ref="assetWarrantyList"
                    mode="remote"
                    title="Asset Warranty"
                    @on-page-change="onPageChange"
                    @on-selected-rows-change="selectionChanged"
                    @on-column-filter="onColumnFilter"
                    @on-per-page-change="onPerPageChange"
                    @on-sort-change="onSortChange"
                    :totalRows="totalRecords"
                    :columns="columns"
                    :rows="rows"
                    :pagination-options="{
                        enabled: (totalRecords > serverParams.perPage ? true:false),
                        position: 'bottom',
                        perPage: perPage,
                        perPageDropdown:dropDownPerPage,
                        dropdownAllowAll: false,
                    }"
                    :select-options="{
                    enabled: false,
                    selectOnCheckboxOnly: true, // only select when checkbox is clicked instead of the row
                    selectionInfoClass: 'custom-class',
                    selectionText: 'rows selected',
                    clearSelectionText: 'clear',
                    }"
                    :search-options="{
                    enabled: false,
                    }">
                        <!-- <div slot="selected-row-actions">
                        <template  v-for="(permission, index) in permissions">
                            <button v-bind:key="'add' + index" v-if="permission.name == 'add_warranty' && currentStatus == 'No'" id="deleteCustomerBtn" v-on:click.prevent="addAssetWarranty" class="btn btn-success waves-effect">Add Warranty</button>
                        </template>
                        <template  v-for="(permission, index) in permissions">
                            <button v-bind:key="'remove' + index" v-if="permission.name == 'delete_warranty' && currentStatus == 'Yes'" id="deleteCustomerBtn" v-on:click.prevent="removeAssetWarranty" class="btn btn-success waves-effect">Remove Warranty</button>
                        </template>
                    </div> -->
                </vue-good-table>
            </div>
        </template>
    </div>
</template>
<script>
import Vue from "vue";
import {commonMixins} from '../../mixins/commonMixins';
import {dataTableMixins} from '../../mixins/dataTableMixins';
import EventBus from "../event-bus";
    export default {
        name: "readingList",
        mixins:[commonMixins,dataTableMixins],
       props: {
            assetwarrantiesVal: {
                type: String,
                required: false,
                default:undefined
            }
        },
        data: () => ({
            firstLoad: 0,
            permissions: [],
            selectedFile:"",
            deviceType:"",
            error:"",
            notfound:false,
            notFoundArr:[],
            unitNum:"",
            reading:"",
            section:"",
            id:0,
            columns: [
                {
                    label: 'Code',
                    field: 'code',
                    filterable: true,
                    sortable:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Code", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Name',
                    field: 'name',
                    filterable: true,
                    sortable:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Name", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Item',
                    field: 'coverage_item',
                    filterable: true,
                    sortable:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Coverage Item", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    }
                },
                {
                    label: 'Period',
                    field: 'time',
                    filterable: true,
                    sortable:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Period", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },

                {
                    label: 'Effective Date',
                    field: 'effective_date',
                    filterable: true,
                    sortable:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Expiry Date',
                    field: 'expiry_date',
                    filterable: true,
                    sortable:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "MM/DD/YYYY", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },

                },
                {
                    label: 'Status',
                    field: 'status',
                    filterable: true,
                    sortable:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Status", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },

                },
                {
                    label: 'Delay Time',
                    field: 'delay_time',
                    filterable: true,
                    sortable:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Delay Time", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                 {
                    label: 'Parts',
                    field: 'parts',
                    filterable: true,
                    sortable:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Parts", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                 {
                    label: 'Labour',
                    field: 'labour',
                    filterable: true,
                    sortable:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Labour", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Handling',
                    field: 'handling',
                    filterable: true,
                    sortable:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Handling", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Other',
                    field: 'other',
                    filterable: true,
                    sortable:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Other", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Expense Type',
                    field: 'expense_type',
                    filterable: true,
                    sortable:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Expense Type", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },
                {
                    label: 'Deductible',
                    field: 'deductible',
                    filterable: true,
                    sortable:false,
                    filterOptions: {
                        enabled: false, // enable filter for this column
                        placeholder: "Deductible", // placeholder for filter input
                        filterValue: '', // initial populated value for this filter
                        trigger: "enter" //only trigger on enter not on keyup
                    },
                },

            ],
            rows: [],
            totalRecords: 0,
            customer_value: false,
            loading:false,
            fromDate:"",
            readingError:"",
            unit:"",
            readingDate:"",
            showSelectAllLink:false,
            buttonVis:false,
            warCode:"",
            vehicle_id:"",
            currentStatus:"Yes",
        }),
        metaInfo () {
            if (this.assetwarrantiesVal == undefined) {
                return {
                    title: "Asset Warranty List | " +process.env.COPYRIGHT_NAME
                }
            }
        },
        created: function() {

        },
        beforeDestroy(){
            // this.$root.$off('asset_warranty');
        },
        mounted: function() {

            // this.$root.$on('asset_warranty', () => {
            var self = this;
            var path = window.location.pathname;
            var segments = path.split("/");
            self.vehicle_id = segments[3];
            self.assetwarrantiesVal = "loadList";
            //for now hide unit and name datatable column
            for (let index = 0; index < this.columns.length; index++) {

                if(this.columns[index].field == 'unit_no'){
                    this.$set(this.columns[index], 'hidden', true);
                }

            }
            // self.getPermissions();
            self.loadList();
            // });

        },
        methods: {

            onSelectAll(params) {

                if ( params.selectedRows.length > 0 ) {
                    this.showSelectAllLink = true;
                } else {
                    this.showSelectAllLink = false;
                }
            },
            selectionChanged(param) {
                var self = this;
                var rowData = self.$refs['assetWarrantyList'].selectedRows;
                if(rowData.length > 0){
                    self.buttonVis = true;
                }else{
                    self.buttonVis = false;
                }
                if(param.selectedRows.length == 100) {
                  EventBus.$emit('clear-selection', false);
                } else {
                  EventBus.$emit('clear-all-flags', false);
                }
                console.log(rowData);
            },

            loadList() {
                var self = this;
                var path = window.location.pathname;
                var segments = path.split("/");
                if( self.assetwarrantiesVal == 'dontLoadList' ){
                    return;
                }
                self.loading = true;
                var fields = {
                    vehicle_id:segments[3],
                    page: self.serverParams.page,
                    perPage: self.serverParams.perPage,
                    filters: self.serverParams.columnFilters,
                    sort: self.serverParams.sort,
                    flag: self.flag
                };
                self.firstLoad = 1;
                $.ajax({
                    url: process.env.ROOT_API + "/asset_warranties",
                    type: "GET",
                    data: fields,
                    headers: this.ajxHeaders,
                    dataType: "json",
                    success: function (data) {
                        self.loading = false;
                        console.log(data);
                        // if (data.code == 200) {
                            self.rows = data.content.row;
                            self.totalRecords = data.content.totalRecords;
                        // }
                    },
                    error: function (jqXHR, exception) {
                        self.loading = false;
                        self.generateStatusCodeMessage(jqXHR,true,'asset-warranty-list')

                    }
                });
            },

            addAssetWarranty(){
                var self = this;
                var rowData = self.$refs['assetWarrantyList'].selectedRows;

                $.ajax({
                url: process.env.ROOT_API + "/warranty/add_warranty_vehicles",
                type: "POST",
                data: {arr:rowData,
                vehicle_id:self.vehicle_id},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    self.loading = false;

                    if (data.status == "success") {
                       self.$swal('','Warranty Added Successfully','success');
                       self.loadList();
                    }
                },
                error: function (jqXHR, exception) {

                   self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'asset-warranty-add')
                }
            });
            },
            removeAssetWarranty(){
                var self = this;

                var rowData = self.$refs['assetWarrantyList'].selectedRows;

                $.ajax({
                url: process.env.ROOT_API + "/remove_warranty_vehicles",
                type: "POST",
                data: {arr:rowData,
                vehicle_id:self.vehicle_id,
                flag:'from_view'},
                headers: this.ajxHeaders,
                dataType: "json",
                success: function (data) {

                    self.loading = false;

                    if (data.status == "success") {
                       self.$swal('','Warranty Removed Successfully','success');
                       self.loadList();
                    }
                },
                error: function (jqXHR, exception) {

                   self.loading = false;
                    self.generateStatusCodeMessage(jqXHR,true,'asset-warranty-remove')

                }
            });
            },
            formatString(data) {

                if (data == null){
                }else{
                    var self = this;
                    var value = data.replace(/_/g, " ");
                    var upp = value.toLowerCase().replace(/\b[a-z]/g, function (letter) {
                        return letter.toUpperCase();
                    });
                    return upp;
                }
            },

        }
    };
</script>

<style scope>
</style>



// WEBPACK FOOTER //
// src/components/asset/AssetWarranty.vue